import Vue from 'vue';
import { defineCustomElements as sdsDatePickerWebComponent } from '@pub/sds-date-field/dist/loader';
import '@pub/sds-date-field/dist/sds/themes/vuetify.css';

Vue.config.ignoredElements = ['sds-date-field'];

sdsDatePickerWebComponent(window, {
  //@ts-expect-error this Stencil property is not typed
  transformTagName: (name: string) => `web-${name}`,
});
